// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__zQkMp","password":"PasswordResetForm_password__3NnWz"};